import { OrderDetailsResponse } from '@models/response/order';

const addMenuItemById = (
  order: OrderDetailsResponse,
  updatedOrder: OrderDetailsResponse,
  canAdd: boolean,
  id: string
): OrderDetailsResponse | undefined => {
  const updatedMenuItem = updatedOrder?.orderItems?.find((x) => x.id === id);
  const orderMenuItem = order?.orderItems?.find((x) => x.id === id);

  if (updatedMenuItem) {
    if (updatedMenuItem?.count && updatedMenuItem?.count > 0) {
      return {
        ...updatedOrder,
        orderItems: updatedOrder?.orderItems?.map((item) => {
          let count = 0;
          if (!canAdd) {
            count = (item.count || 0) + 1 > (orderMenuItem?.count || 0) ? item.count || 0 : (item.count || 0) + 1;
          } else {
            count = (item.count || 0) + 1;
          }
          if (item.id === id) {
            return {
              ...item,
              count,
              toppings: item?.toppings?.map((x) => ({
                ...x,
                count,
              })),
            };
          }
          return item;
        }),
      };
    }
  }
  return order;
};

export default addMenuItemById;
